import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateConfigurationTemplateConfigTree } from '@api/configurationTemplates';

import { TConfigurationTemplateUpdateTreeDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONFIGURATION_TEMPLATES, CONFIGURATION_TEMPLATES_UPDATE_CONFIG_TREE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseQueryConfigurationTemplatesConfigTreeReturned {
	isLoadingUpdateConfigTree: boolean;
	updateTree: UseMutateFunction<any, any, TConfigurationTemplateUpdateTreeDTO, any>;
}

const useMutateConfigurationTemplateUpdateConfigTree = ({
	onSuccess,
}: Partial<IOnSuccess>): IUseQueryConfigurationTemplatesConfigTreeReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<TConfigurationTemplateUpdateTreeDTO>({
		mutationKey: [CONFIGURATION_TEMPLATES_UPDATE_CONFIG_TREE],
		mutationFn: updateConfigurationTemplateConfigTree,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateTemplateName,
				type: ESnackbarTypes.success,
			}));

			if (onSuccess) {
				onSuccess();
			}

			return queryClient.invalidateQueries([CONFIGURATION_TEMPLATES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		updateTree: mutate,
		isLoadingUpdateConfigTree: isLoading,
	};
};

export default useMutateConfigurationTemplateUpdateConfigTree;
